<section *ngIf="loaded == 1">
    <div  class="cw " fxLayout="column" fxFlex="50%" fxFlex.lt-lg="75%" fxFlex.lt-md="100%"  fxLayoutAlign="center">
        <div fxLayout="column" fxFlex="50%" fxLayoutAlign="center">

            <div class="mgb10 border radius3 pd10">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <h6 class="gray-8 ft14 ft500"> Constancia de completación de capacitación</h6>
                    <mat-icon class="ftxxl gray-4 linkIcon"> school</mat-icon>
                </div>

                <hr>
                <p class="mgb05"> <span class="gray-6">Titulo del curso:</span>  {{tituloCurso}}</p>
                <p class="mgb05"> <span class="gray-6">Descripción</span> {{descripcionCurso}}</p>
                <p class="mgb05"> <span class="gray-6">Duracion:</span> {{duracionCurso}} horas</p>
                <p class="mgb05"> <span class="gray-6">Nombre del instructor: </span>{{nombreInstructor}}</p>
                <p class="mgb05"> <span class="gray-6">Nombre del estudiante:</span>{{nombreUsuario}}</p>
                <p class="mgb05"> <span class="gray-6">Fecha de completacion:</span> {{fechaTransformada}}</p>
                <p class="mgb20"> <span class="gray-6">Cógido único de certificado:</span> {{id}}</p>
                <div fxLayout="row" fxLayoutAlign="space-between end">
                    <button class="darkButton ft500" (click)="downloadPDF()">Descargar certificado</button>
                    <span class="mgl10 ft10 gray-6">. Certificado de completación emitido por Predyc.
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
<section *ngIf="loaded == 0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</section>

